// React
import React from "react";
import {isMobile} from "react-device-detect";

// import RegressionV2 from "./components/Diagram/regression";

//Components
import RegressionV2 from "./components/Diagram/regression";
import Parliament from "./components/Diagram/parliament";
import PollsTable from "./components/Tables/polls-table";
import AvgPartiesTable from "./components/Tables/avg-parties-table";
import AvgPartiesIntTable from "./components/Tables/avg-parties-int-table";
import RegressionV2Ev from "./components/Diagram/regression-ev";
import RegressionV2Int from "./components/Diagram/regression-int";

//Components Lazy Loading
// const PollingCompanies = React.lazy(() => import("./components/Menus/polling-companies"));

const App = () => {

    return (
      <div className={'App ' + (isMobile ? 'isMobile' : '')}>
            <RegressionV2Int/>
            <AvgPartiesIntTable/>
            <RegressionV2Ev/>
            <AvgPartiesTable/>
            {/* <Parliament/> */}
            <PollsTable/>
        </div>
    );
}

export default App;
